"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _classify = require("../../utils/classify");
var _menu = require("../../utils/menu");
var _qa = require("../../utils/qa");
var _MenuOptionButton = require("./MenuOptionButton");
var _SearchInput = require("../SearchInput");
var _Text = require("../Text");
var _MenuModule = _interopRequireDefault(require("./Menu.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Render first available option set

const menuSizeMedium = 276,
  menuSizeSmall = 228;
const buttonSizeMedium = 40,
  buttonSizeSmall = 32;
const RenderOption = _ref => {
  let {
    options,
    composeOptions,
    groupTitleOptions,
    classNames,
    searchText = '',
    showResultText = true,
    testId,
    staticLabels = {
      RESULT: 'result',
      RESULTS: 'results',
      SEARCH_PLACEHOLDER: 'Search...'
    },
    ...restProps
  } = _ref;
  const {
    allowSearch,
    size,
    virtualization = {
      enable: false,
      menuHeight: null,
      itemHeight: null
    }
  } = restProps;
  if (options && Array.isArray(options) && options.length) {
    const optionsFiltered = !allowSearch ? options : (0, _menu.getFilteredOptionsFromSearchText)(options, searchText);
    const finalResultText = !allowSearch ? '' : (0, _menu.getFilteredOptionsResultText)(optionsFiltered, staticLabels);
    const {
      enable: isVirtualizationEnabled,
      menuHeight,
      itemHeight
    } = virtualization;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [allowSearch && showResultText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
        className: _MenuModule.default.filterOptionsResultText,
        color: "tertiary",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'result-text'
        }),
        children: finalResultText
      }), virtualization && isVirtualizationEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.FixedSizeList, {
        height: menuHeight || (size === 'medium' ? menuSizeMedium : menuSizeSmall),
        itemSize: itemHeight || (size === 'medium' ? buttonSizeMedium : buttonSizeSmall),
        itemCount: optionsFiltered.length,
        width: "initial",
        children: _ref2 => {
          let {
            index: idx,
            style
          } = _ref2;
          const buttonOption = optionsFiltered[idx];
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuOptionButton.MenuOptionButton, {
              option: buttonOption,
              classNames: classNames,
              style: style,
              ...restProps,
              isLastItem: idx === optionsFiltered.length - 1,
              testId: (0, _qa.generateTestId)({
                base: testId,
                slot: 'option',
                index: idx.toString()
              })
            })
          }, buttonOption.key);
        }
      }) : optionsFiltered.map((option, idx) => /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuOptionButton.MenuOptionButton, {
          option: option,
          classNames: classNames,
          ...restProps,
          isLastItem: idx === optionsFiltered.length - 1,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'option',
            index: idx.toString()
          })
        })
      }, option.key))]
    });
  }
  if (composeOptions && Array.isArray(composeOptions) && composeOptions.length) {
    const optionsFiltered = !allowSearch ? composeOptions : (0, _menu.getFilteredComposeOptionsFromSearchText)(composeOptions, searchText);
    const finalResultText = !allowSearch ? '' : (0, _menu.getFilteredComposeOptionsResultText)(optionsFiltered, staticLabels);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [allowSearch && showResultText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
        className: _MenuModule.default.filterOptionsResultText,
        color: "tertiary",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'result-text'
        }),
        children: finalResultText
      }), optionsFiltered.map((composeMenuOptions, index) =>
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      (0, _jsxRuntime.jsx)("span", {
        className: _MenuModule.default.menuDivider,
        children: composeMenuOptions.map((option, idx) => /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuOptionButton.MenuOptionButton, {
            option: option,
            classNames: classNames,
            ...restProps,
            isLastItem: index === optionsFiltered.length - 1 && idx === composeMenuOptions.length - 1,
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'option',
              index: `${index}-${idx}`
            })
          })
        }, option.key))
      }, index))]
    });
  }
  if (groupTitleOptions && Array.isArray(groupTitleOptions) && groupTitleOptions.length) {
    const optionsFiltered = !allowSearch ? groupTitleOptions : (0, _menu.getFilteredGroupTitleOptionsFromSearchText)(groupTitleOptions, searchText);
    const finalResultText = !allowSearch ? '' : (0, _menu.getFilteredGroupTitleOptionsResultText)(optionsFiltered, staticLabels);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [allowSearch && showResultText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.FormLabelSmall, {
        className: _MenuModule.default.filterOptionsResultText,
        color: "tertiary",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'result-text'
        }),
        children: finalResultText
      }), optionsFiltered.map((optionsGroup, index) =>
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      (0, _jsxRuntime.jsxs)(React.Fragment, {
        children: [!!optionsGroup.groupTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classify.classify)(_MenuModule.default.groupTitleWrapper, classNames?.groupTitle),
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'group-title',
            index: index.toString()
          }),
          children: optionsGroup.groupTitle
        }), optionsGroup.options?.map((option, idx) => /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuOptionButton.MenuOptionButton, {
            option: option,
            classNames: classNames,
            ...restProps,
            isLastItem: index === optionsFiltered.length - 1 && idx === (optionsGroup.options && optionsGroup.options.length - 1),
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'option',
              index: `${index}-${idx}`
            })
          })
        }, option.key))]
      }, index))]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
const Menu = exports.Menu = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    classNames,
    size = 'medium',
    width,
    isFluid = true,
    allowSearch,
    virtualization = {
      enable: false,
      menuHeight: null,
      itemHeight: null
    },
    header,
    footer,
    staticLabels,
    testId
  } = props;
  const [searchText, setSearchText] = React.useState('');
  const {
    menuHeight
  } = virtualization;
  const hasHeader = header ? true : false;
  const hasFooter = footer ? true : false;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.classify)(_MenuModule.default.menuCard, {
      [_MenuModule.default.fluid]: isFluid,
      [_MenuModule.default.medium]: size === 'medium',
      [_MenuModule.default.mediumWithHeader]: size === 'medium' && hasHeader && !hasFooter,
      [_MenuModule.default.mediumWithFooter]: size === 'medium' && !hasHeader && hasFooter,
      [_MenuModule.default.mediumWithHeaderAndFooter]: size === 'medium' && hasFooter && hasHeader,
      [_MenuModule.default.small]: size === 'small',
      [_MenuModule.default.smallWithHeader]: size === 'small' && hasHeader && !hasFooter,
      [_MenuModule.default.smallWithFooter]: size === 'small' && !hasHeader && hasFooter,
      [_MenuModule.default.smallWithHeaderAndFooter]: size === 'small' && hasFooter && hasHeader,
      [_MenuModule.default.menuCardTopPaddingZero]: header,
      [_MenuModule.default.menuCardBottomPaddingZero]: footer
    }, classNames?.wrapper),
    style: {
      width,
      maxHeight: menuHeight ? menuHeight + 'px' : ''
    },
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: [hasHeader && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.classify)(_MenuModule.default.menuHeader, classNames?.header),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'header'
      }),
      children: header
    }), allowSearch && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {
      value: searchText,
      onChange: e => setSearchText(e.target.value),
      onClear: () => setSearchText(''),
      size: size,
      placeholder: staticLabels?.SEARCH_PLACEHOLDER ?? 'Search...',
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'search'
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(RenderOption, {
      ...props,
      searchText: searchText,
      testId: testId
    }), hasFooter && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.classify)(_MenuModule.default.menuFooter, classNames?.footer),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'footer'
      }),
      children: footer
    })]
  });
});